<!--订单详情-->
<template>
  <div class="details-container" :style="'min-height:'+min_height+'px;'">
    <headerIndex/>
    <div class="details-content" :style="'min-height:'+min_heights+'px;'">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item><a @click="back">返回订单管理</a></el-breadcrumb-item>
      </el-breadcrumb>
      <div class="order-details">
        <!--订单执行步骤图-->
        <div class="order-step" v-if="state != 7 && state != -4 && state!=5">
          <steps :data="detailsData"/>
        </div>
        <!--商品信息-->
        <div class="order-table">
          <orderTable :state="state" :data="[detailsData]" :type="type"/>
        </div>
        <div class="order-info">
          <el-row :gutter="16">
            <!--订单信息-->
            <el-col :span="9">
              <order-info :state="state" :data="detailsData" ref="ordersInfo"/>
            </el-col>
            <!--状态信息-->
            <el-col :span="15">
              <status-info :state="state" :data="detailsData" :height="height"/>
            </el-col>
          </el-row>
        </div>
        <!--付款信息-->
        <payment-info :state="state" :data="detailsData" class="payment-info" @getOrderDetails="getOrderDetails"/>
      </div>
    </div>
    <Hang/>
    <home_footer/>
  </div>
</template>
<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import steps from "@/components/orderModule/steps";
import orderTable from "@/components/orderModule/orderTable";
import OrderInfo from "@/components/orderModule/orderInfo";
import StatusInfo from "@/components/orderModule/statusInfo";
import PaymentInfo from "@/components/orderModule/paymentInfo";
import {getMyOrderDetails} from '@/api/orderApi'
export default {
  name: "orderDetails",
  components: {PaymentInfo, StatusInfo, OrderInfo, Hang, headerIndex, home_footer,steps,orderTable},
  data() {
    return {
      min_height: document.documentElement.clientHeight,
      min_heights: document.documentElement.clientHeight-315,
      detailsData:{},
      state: 0,
      height:0,
      orderId:0,
      cid:0,
      type:0,
    }
  },
  methods:{
    back(){
      this.$router.back(-1);
    },
    /*获取订单详情信息*/
    getOrderDetails(){
      getMyOrderDetails({order_id: this.orderId, uid: this.cid, request: 'form'}).then(res=>{
        if (res.code==200){
          this.type=res.content.type;
          /* type: 1 为一般订单详情 （不包括售后） 2 售后订单详情*/
          if (res.content.type==1){
            this.detailsData=res.content.sselectMyOrderDetailsVo;
            this.state=this.detailsData.state;
          }else{
            this.detailsData=res.content.myOrderRefundVo;
          }
          this.height=this.$refs.ordersInfo.$el.clientHeight;
        }
      })
    }
  },
  watch:{
    height:function(){
      let that=this;
      this.$nextTick(function(){
        this.height=that.$refs.ordersInfo.$el.clientHeight;
      });
    }
  },
  mounted() {
    this.getOrderDetails();
  },
  beforeMount() {
    this.state = Number(this.$route.query.state);
    this.orderId=Number(this.$route.query.id);
    this.cid=JSON.parse(sessionStorage.getItem('loginData')).cid;
  }
}
</script>
<style scoped>
.details-container >>> .details-content .el-breadcrumb__item:last-child .el-breadcrumb__inner, .el-breadcrumb__item:last-child .el-breadcrumb__inner a, .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover, .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  color: #333333;
  cursor: pointer;
  font-size: 14px;
  font-family: 'SourceHanSansCN';
  font-weight: 100;
}
</style>
<style scoped lang="scss">
.details-container {
  background: #F1F1F1;
  .details-content {
    padding: 20px 18%;
    min-width: 76rem;
    background: #F1F1F1;
    .order-details{
      background: #ffffff;
      padding: 20px;
      margin-top: 20px;
      .order-step{
        padding-bottom: 40px;
      }
      .order-table{
        padding-bottom: 40px;
      }
      .order-info{
        padding-bottom: 40px;
      }
      .payment-info{
        padding-bottom: 40px;
      }
    }
  }
}
</style>